import React, { memo } from "react"
import { Container, Corner, EnvIndicatorContainer } from "./style"

function EnvIndicator() {
  let envName = import.meta.env.VITE_ENVIRONMENT

  switch (envName) {
    case "INTEGRATION":
      envName = "INT"
      break
    default:
  }

  return (
    <>
      {envName && envName !== "PRODUCTION" && (
        <EnvIndicatorContainer>
          <Container>
            <Corner envName={envName}>
              <span>{envName}</span>
            </Corner>
          </Container>
        </EnvIndicatorContainer>
      )}
    </>
  )
}
export default memo(EnvIndicator)
